<template>
  <div id="app">
    <!--<router-view />-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <div id="nav" v-if="$route.meta.tabBarShow">
      <van-tabbar
        v-model="active"
        active-color="#1666c4"
        inactive-color="#b5b5b5"
        :fixed="true"
        :border="false"
        :style="{backgroundColor:'#f2f2f2',borderTop:'1px solid #dedede'}"
      >
        <van-tabbar-item to="/">
          <van-icon class="iconfont" class-prefix="icon" slot="icon" name="home"></van-icon>首页
        </van-tabbar-item>
        <van-tabbar-item @click="mfpgDlgShow=true;dialogInit('set_AddDevicePublishInfo','设备发布')">
          <van-icon class="iconfont" class-prefix="icon" slot="icon" name="jx"></van-icon>设备发布
        </van-tabbar-item>
        <van-tabbar-item @click="mfpgDlgShow=true;dialogInit('set_AddDeviceBuyInfo','设备求购')">
          <van-icon class="iconfont" class-prefix="icon" slot="icon" name="buy"></van-icon>设备求购
        </van-tabbar-item>
        <van-tabbar-item to="/mine">
          <van-icon class="iconfont" class-prefix="icon" slot="icon" name="mine"></van-icon>我的
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <van-dialog v-model="qgDlgShow" title="设备求购" :show-confirm-button="false">
      <van-icon name="cross" class="dlgClose" size="20" @click="qgDlgShow=!qgDlgShow" />
      <van-cell-group>
        <van-field label="手机号" placeholder="请输入手机号" />
        <van-field rows="1" autosize label="意向设备" type="textarea" placeholder="请输入意向设备" />
      </van-cell-group>
      <van-button type="danger" block style="margin-top:0.4rem;">提交信息</van-button>
    </van-dialog>
    <van-dialog v-model="fbDlgShow" title="设备发布" :show-confirm-button="false">
      <van-icon name="cross" class="dlgClose" size="20" @click="fbDlgShow=!fbDlgShow" />

      <van-field label="手机号" placeholder="请输入手机号" />

      <van-button type="danger" block style="margin-top:0.4rem;">快速发布</van-button>
    </van-dialog>
    
    <SetDevice :mfpgDlgShow="mfpgDlgShow" :dlgTitle="dlgTitle" :dlgPath="dlgPath" v-on:fun="change"></SetDevice>
  
  </div>
</template>

<script>
import EquipmentService from "@/services/EquipmentService";
import validate from "@/utils/common";
import SetDevice from '@/components/equipment/SetDevice';
export default {
	  components: {
    SetDevice
  },
  data() {
    return {
    	openId: "oT6iQt9V4flDNpI_zIB89kyu12uc",
      pService: null,
      active: 0,
      qgDlgShow: false,
      fbDlgShow: false,
      dlgTitle:'免费评估',
      dlgPath:'',
      mfpgDlgShow:false,
    };
  },
   created() {
  	if(localStorage.getItem('openId') !=="null"){
  		this.openId = localStorage.getItem('openId');
  	}
    this.pService = new EquipmentService();   

  },
  methods: {
    qgDlg: function() {
      this.qgDlgShow = true;
    },
    fbDlg: function() {
      this.fbDlgShow = true;
    },
    change(data){
         this.mfpgDlgShow=data;
    },
    dialogInit(path,title){
    	this.dlgTitle = title;
    	this.dlgPath = path;
    	this.mfpgDlgShow = true; 
    	//this.getPrivince();
    }
  }
};
!(function() {
  var n = document.documentElement,
    e = "orientationchange" in window ? "orientationchange" : "resize",
    t = function() {
      var e = document.body.clientWidth;
      e &&
        (n.style.fontSize =
          (100 * (e / 750) > 55.3333 ? 55.3333 : 100 * (e / 750)) + "px");
    };
  document.addEventListener &&
    (window.addEventListener(e, t, !1),
    document.addEventListener("DOMContentLoaded", t, !1));
})();
</script>

<style>
@import "assets/css/common";
#nav .iconfont {
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue